import { render, staticRenderFns } from "./SmallDetailsMultipleLogos.vue?vue&type=template&id=77027404"
import script from "./SmallDetailsMultipleLogos.vue?vue&type=script&lang=ts"
export * from "./SmallDetailsMultipleLogos.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SmallDetailsMultipleLogos.vue?vue&type=style&index=0&id=77027404&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./SmallDetailsMultipleLogos.vue?vue&type=style&index=1&id=77027404&prod&lang=css")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports